<template>
  <page :load="loadInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap align-end>
        <v-flex xs11>
          <card-menu :items="cardMenu" @cardReturn="visibleControl" subMenu></card-menu>
        </v-flex>
        <v-flex xs1>
          <v-container fluid class="pa-0" align="right">
            <span align="right">
              <div class="text-center">
                <v-tooltip top>
                  <template v-slot:activator="{ on }">
                    <v-btn class="mx-2" fab dark color="error" v-on="on" @click.native="doButtons('remove')"><v-icon dark>mdi-delete</v-icon></v-btn>
                  </template>
                  <span>Delete Risk Survey</span>
                </v-tooltip>
              </div>
            </span>
          </v-container>
        </v-flex>
      </v-layout>
      <!-- <message :messages="messages"></message> -->
      <v-layout row wrap>
        <v-flex xs12>
          <form>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <!-- <div slot="header">
                  <v-icon>mdi-filter-variant</v-icon> Filters
                </div> -->
                  <div>
                    <!--lcd_20201202-->
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn class="mx-2" fab dark small color="teal" v-on="on" @click.native.stop="showFilterList = true">
                          <v-icon dark>mdi-format-list-bulleted</v-icon>
                        </v-btn>
                      </template>
                      <span>Show Saved Filters</span>
                    </v-tooltip>
                    {{ filtersTitle }}
                    <span class="caption grey--text font-weight-light">
                      {{ defaultFilter.filterName !== undefined ? ' (' + defaultFilter.filterName + ')' : '' }}</span
                    >
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card>
                    <v-card-text>
                      <v-container fluid grid-list-sm>
                        <v-layout row wrap>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.survNo"
                              :label="filtersLabel.survNo"
                              :error-messages="errors.collect('survNo')"
                              data-vv-name="survNo"
                              :data-vv-as="filtersLabel.survNo"
                              v-validate="'entry|max:8'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <cal-picker
                              v-model="filters.survDate"
                              :label="filtersLabel.survDate"
                              :error-messages="errors.collect('survDate')"
                              data-vv-name="survDate"
                              :data-vv-as="filtersLabel.survDate"
                            ></cal-picker>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.survId"
                              :label="filtersLabel.survId"
                              :error-messages="errors.collect('survId')"
                              data-vv-name="survId"
                              :data-vv-as="filtersLabel.survId"
                              v-validate="'entry|numeric'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.insdName"
                              :label="filtersLabel.insdName"
                              :error-messages="errors.collect('insdName')"
                              data-vv-name="insdName"
                              :data-vv-as="filtersLabel.insdName"
                              v-validate="'entry|max:50'"
                            ></v-text-field>
                          </v-flex>
                          <v-flex lg4 xs6>
                            <v-text-field
                              v-model="filters.addr1"
                              :label="filtersLabel.addr1"
                              :error-messages="errors.collect('addr1')"
                              data-vv-name="addr1"
                              :data-vv-as="filtersLabel.addr1"
                              v-validate="'entry|max:40'"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                      <v-btn color="primary" text @click.native="saveFilter = true">Save Current Filters</v-btn>
                      <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-flex>
      </v-layout>
      <v-layout>
        <!-- Risk Survey Details Tabs Style -->
        <v-flex xs12>
          <v-card>
            <!-- Tabs in Risk Survey list -->
            <v-tabs left v-model="tab">
              <v-tab v-for="(detailTab, x) in detailTabs" :key="x" @click="doColumn(detailTab, columns)" :disabled="doDisabledTab(detailTab)">{{
                detailTab
              }}</v-tab>
              <v-spacer></v-spacer>
              <v-btn class="mt-2" color="primary" @click.native="doCreateRiskSurvey">
                <span>{{ labels.createSurvey }}</span>
                <v-icon right dark>mdi-plus</v-icon>
              </v-btn>
              <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                <template v-slot:activator="{ on }">
                  <v-btn color="secondary" class="white--text mt-2 ml-2 mr-2" v-on="on">
                    <span>Columns</span>
                    <v-icon right dark>mdi-table-column-plus-after</v-icon>
                  </v-btn>
                </template>
                <v-card v-if="tab === 0">
                  <v-card-text>
                    <template v-if="surveyColumns.length > 0">
                      <v-checkbox
                        v-for="column in surveyColumns"
                        :key="column.value"
                        :label="column.text"
                        :value="column.value"
                        v-model="selectedSurveyColumns"
                      ></v-checkbox>
                    </template>
                    <template v-else> No column found </template>
                  </v-card-text>
                </v-card>
              </v-menu>
              <v-tabs-items v-model="tab">
                <v-tab-item :key="1">
                  <v-flex xs12 class="mt-2">
                    <v-data-table
                      :headers="listSurveyHeaders"
                      :items="items"
                      v-bind:options.sync="paginationSurveyHeader"
                      :server-items-length="totalItems"
                      :loading="loading"
                      class="elevation-1"
                      :footer-props="{'items-per-page-options': itemsPerPage }"
                      :no-data-text="noDataText"
                    >
                      <template v-slot:item="row"
                        ><tr>
                          <td v-for="column in selectedSurveyColumns" :key="column">
                            {{ row.item[column] }}
                          </td>
                          <td class="table-action-header">
                            <table-action
                              :rowData="row"
                              :query="canQuery(row)"
                              :review="canReview(row)"
                              :remove="canRemove(row)"
                              @query="doQuery(row)"
                              @review="doReview(row)"
                              @remove="doPromptRemove(row.item)"
                              :loading="loading"
                            ></table-action>
                          </td></tr
                      ></template>
                    </v-data-table>
                  </v-flex>
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="processing" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-3">
          Processing...
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <confirm v-model="promptRemove" @ok="doDelete">
      <p>{{ labels.promptRemove }}</p>
      <div class="queryValue">Survey No.: {{ selectedRiskSurvey.survNo }}</div>
      <div class="queryValue">Version Count: {{ selectedRiskSurvey.verCnt }}</div>
    </confirm>

    <v-dialog v-model="showErrorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="messages.length > 0" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li v-for="(error, index) in messages" :key="index">
                {{ error.message }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showFilterList" width="800px" persistent>
      <SearchFilter
        :boolRefresh="showFilterList"
        :filterTitle="'Saved Filters - Risk Survey Listing'"
        @close="showFilterList = false"
        :filterCode="filterCode"
        @applyDefaultFilter="applyDefaultFilter"
      ></SearchFilter>
    </v-dialog>

    <v-dialog v-model="saveFilter" width="800px" persistent>
      <UpdateSearchFilter
        :boolRefresh="saveFilter"
        :dialogTitle="'Filter'"
        :actionName="'new'"
        :filters="filters"
        @close="saveFilter = false"
        @reloadList="reloadList"
        :filterCode="filterCode"
        @applyDefaultFilter="applyDefaultFilter"
      ></UpdateSearchFilter>
    </v-dialog>
  </page>
</template>

<script>
import clone from 'clone'
import { listPolicyMixin } from '../../listPolicyMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import { RISK_SURVEY_NEW_MODE, RISK_SURVEY_REVIEW_MODE, RISK_SURVEY_QUERY_MODE, RISK_SURVEY_TAB } from '@/store/types'
import { removeTime, formatDisplayDateTime2 } from '@/utils/date'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import SearchFilter from '@/components/core/common/dialog/SearchFilter'
import UpdateSearchFilter from '@/components/core/common/dialog/UpdateSearchFilter'

export default {
  data() {
    return {
      filterCode: 'SUR',
      newFilter: false,
      saveFilter: false,
      showFilterList: false,
      defaultFilter: {},
      paginationSurveyHeader: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      cardMenu: [
        { text: 'Risk Survey', icon: 'mdi-file-document', name: '', params: { tab: 'riskSurvey' }, access: '', default: true },
        { text: 'Endorsement', icon: 'mdi-file-multiple', name: '', params: { tab: 'endorse' }, access: '' }
      ],
      visibleTab: {},
      tab: undefined,
      detailTabs: ['Risk Survey Details'],
      surveyColumns: [
        { text: 'Survey No.', value: 'survNo' },
        { text: 'Version Count', value: 'verCnt' },
        { text: 'Survey Date', value: 'survDate' },
        { text: 'Insured Name', value: 'insdName' },
        { text: 'Address', value: 'addr1' },
        { text: 'Surveyor', value: 'survId' },
        { text: 'Policy No.', value: 'polNo' },
        { text: 'Address 2', value: 'addr2' },
        { text: 'Address 3', value: 'addr3' },
        { text: 'Address 4', value: 'addr4' },
        { text: 'Contact Person', value: 'contactName' },
        { text: 'Telephone No.', value: 'telNo' },
        { text: 'Next Survey Date', value: 'nxtSurvDate' },
        { text: 'Next Survey By', value: 'nxtSurvBy' }
      ],
      selectedSurveyColumns: ['survNo', 'verCnt', 'survDate', 'insdName', 'addr1', 'survId'],
      params: {
        review: [
          { label: 'Review', value: 'Review' },
          { label: 'Endorse', value: 'Endorse' }
        ]
      },
      filters: {
        survNo: null,
        survDate: null,
        survId: null,
        insdName: null,
        addr1: null
      },
      filtersLabel: {
        survNo: 'Survey No',
        survDate: 'Survey Date',
        survId: 'Survey ID',
        insdName: 'Insured Name',
        addr1: 'Address'
      },
      labels: {
        deleteSurvey: 'Delete',
        createSurvey: 'New Risk Survey',
        promptRemove: 'Are you sure you want to delte the selected Risk Survey?'
      },
      riskSurveyList: [],
      riskList: [],
      polTypeList: [],
      processing: false,
      showErrorDialog: false,
      promptRemove: false,
      selectedRiskSurvey: {},
      filtersTitle: '',
      isAfterDefFilter: false
    }
  },
  watch: {
    'paginationSurveyHeader': function (value) {
      if (this.isAfterDefFilter === true) {
        this.fetchData(false)
      }
    },
    tab: function (value) {
      if (value === 0) {
        this.doColumn('Risk Survey Details', this.columns)
      }
    },
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  methods: {
    visibleControl(data) {
      if (typeof data !== 'undefined') {
        this.visibleTab = { ...data }
        this.doButtons(this.visibleTab.tab)
      } else {
        this.visibleTab = {}
      }
    },
    async loadInit() {
      await Promise.all([this.$store.dispatch('searchFilterInit')])
      this.getDefaultFilter()
      this.initCommonUtilMenu()
    },
    reloadList(filterName) {
      this.defaultFilter.filterName = filterName
      this.saveFilter = false
      this.fetchData()
    },
    async doInit() {
      this.$store.commit(RISK_SURVEY_TAB, 0)
      if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
        await this.$store.dispatch('specialFuncUWInit').then(() => {
          this.$store.dispatch('riskSurveyInit').then(() => {
            this.fetchData(false)
          })
        })
      }
    },
    async fetchData(options) {
      if (this.showRiskSurveyTabs) {
        const apiUrl = this.riskSurveyMenu.getRiskSurveyList
        if (apiUrl) {
          try {
            this.loading = true
            const { page, itemsPerPage } = this.paginationSurveyHeader
            const expand = {
              page: page - 1,
              size: itemsPerPage,
              options
            }
            let massageFilters = clone(this.filters)
            if (massageFilters.survDate) {
              massageFilters.survDate = formatDisplayDateTime2(removeTime(massageFilters.survDate))
            }
            const result = await this.$http.get(
              filterQuery(expandURI(apiUrl, expand), massageFilters, this.paginationSurveyHeader.sortBy, this.paginationSurveyHeader.sortDesc)
            )
            if (result.data) {
              this.totalItems = result.data.totalElements
              const { data } = result.data
              if (data) {
                this.items = []
                data.map((riskSurvey) => {
                  const convertList = {
                    survNo: riskSurvey.survNo,
                    verCnt: riskSurvey.verCnt,
                    survDate: this.formatDate(riskSurvey.survDate),
                    insdName: riskSurvey.insdName,
                    addr1: riskSurvey.addr1,
                    survId: riskSurvey.survId,
                    polNo: riskSurvey.polNo,
                    addr2: riskSurvey.addr2,
                    addr3: riskSurvey.addr3,
                    addr4: riskSurvey.addr4,
                    contactName: riskSurvey.contactName,
                    telNo: riskSurvey.telNo,
                    nxtSurvDate: riskSurvey.nxtSurvDate,
                    nxtSurvBy: riskSurvey.nxtSurvBy
                  }
                  this.items.push(convertList)
                })
              } else {
                this.items = []
              }
              this.riskSurveyList = this.items
            }
            this.loading = false
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
            this.loading = false
          }
        } else {
          this.errorMessage('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    applyDefaultFilter(filterData) {
      this.defaultFilter = filterData
      if (this.defaultFilter.filters !== undefined) {
        this.filters = this.defaultFilter.filters
      }
      this.showFilterList = false
      this.fetchData(false)
    },
    async getDefaultFilter() {
      const apiUrl = this.$store.state.searchFilter.menu.defaultFilter
      if (apiUrl) {
        try {
          this.loading = true
          const expand = {
            filterCode: this.filterCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          this.initialLoad = false
          if (data) {
            this.defaultFilter.filterName = data.defaultFilter.filterName
            this.defaultFilter.filterDesc = data.defaultFilter.filterDesc
            this.defaultFilter.filterCode = data.defaultFilter.filterCode
            this.defaultFilter.filters = JSON.parse(data.defaultFilter.filterContent)
            if (this.defaultFilter.filters !== undefined) {
              this.filters = this.defaultFilter.filters
              this.valMainClasses()
            }
            this.doInit()
          } else {
            this.doInit()
          }
          this.isAfterDefFilter = true
        } catch (err) {
          this.loading = false
        }
      }
    },
    doCreateRiskSurvey() {
      this.$store.commit(RISK_SURVEY_NEW_MODE)
      this.$store.dispatch('resetSurveyMaster')
      this.$store.dispatch('resetSurveyDetails')
      this.$router.push({ name: 'riskSurveyHeader' })
    },
    doReviewRiskSurvey() {
      this.$store.commit(RISK_SURVEY_REVIEW_MODE)
      this.$router.push({ name: 'riskSurveyHeader' })
    },
    doButtons(data) {
      this.fetchData(false)
      if (data === 'riskSurvey') {
        this.review = 'riskSurvey'
        this.filtersTitle = 'Filters for Risk Survey'
      } else if (data === 'endorse') {
        this.review = 'endorse'
        this.filtersTitle = 'Filters for Endorsement'
      } else if (data === 'remove') {
        this.review = 'remove'
        this.filtersTitle = 'Filters for Delete Risk Survey'
      }
    },
    canQuery() {
      return this.review === 'riskSurvey' || this.review === 'endorse'
    },
    canReview() {
      return this.review === 'riskSurvey' || this.review === 'endorse'
    },
    canRemove() {
      return this.review === 'remove'
    },
    doQuery(data) {
      this.processing = true
      this.$store.commit(RISK_SURVEY_QUERY_MODE)
      this.$store.dispatch('reviewSurveyMaster', data).then((result) => {
        if (result) {
          this.$store.dispatch('reviewSurveyDetails', data).then((result2) => {
            if (result2) {
              this.processing = false
              this.$router.push({ name: 'riskSurveyHeader' })
            }
          })
        }
      })
    },
    doReview(data) {
      this.processing = true
      this.$store.commit(RISK_SURVEY_REVIEW_MODE)
      this.$store.dispatch('reviewSurveyMaster', data).then((result) => {
        if (result) {
          this.$store.dispatch('reviewSurveyDetails', data).then((result2) => {
            if (result2) {
              this.processing = false
              this.$router.push({ name: 'riskSurveyHeader' })
            }
          })
        }
      })
    },
    doPromptRemove(item) {
      this.resetMessages()
      this.promptRemove = true
      this.selectedRiskSurvey = item
    },
    async doDelete() {
      const apiURI = this.riskSurveyMenu.deleteRiskSurvey
      if (apiURI) {
        const expand = {
          survNo: this.selectedRiskSurvey.survNo,
          verCnt: this.selectedRiskSurvey.verCnt
        }
        await this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.fetchData(false)
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.survNo = null
      this.filters.survDate = null
      this.filters.survId = null
      this.filters.insdName = null
      this.filters.addr1 = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          // this.paginationSurveyHeader.page = 1
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doRiskSurveyTabs() {
      this.showRiskSurveyTabs = true
      if (!this.loadRiskSurvey) {
        this.items = []
        this.loadRiskSurvey = true
        this.doInit()
      } else {
        this.items = this.riskSurveyList
      }
    },
    doColumn(detailTab, columns) {
      this.columns = []
      if (detailTab === 'Risk Survey Details') {
        this.apiUrl = this.$store.state.underwriting.specialFuncUWSettings.menu.getRiskSurveyList
        this.doRiskSurveyTabs()
      }
    },
    doDisabledTab(detailTab) {
      return detailTab === 'Risk Details' && this.showRiskTabs === false
    }
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.fetchData(false)
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.fetchData(false)
      })
    }
  },
  created() {},
  async mounted() {},
  mixins: [listPolicyMixin, recordLockMixin],
  components: {
    SearchFilter,
    UpdateSearchFilter
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    }
  }
}
</script>

<style lang="scss">
@import '../../../../../assets/scss/underwriting.scss';
</style>
